import { render, staticRenderFns } from "./GameFormCard.vue?vue&type=template&id=9393bab0"
import script from "./GameFormCard.vue?vue&type=script&lang=js"
export * from "./GameFormCard.vue?vue&type=script&lang=js"
import style0 from "./GameFormCard.vue?vue&type=style&index=0&id=9393bab0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports